import { combineReducers } from 'redux';

import rentalPlanIndex from './rentalPlanIndex';

export default combineReducers({
    rentalPlanIndex,
});
